import { Box } from '@chakra-ui/layout';
import { useEffect, useRef } from 'react';

export const EditGrid = ({
  columns,
  rows,
  width,
  height,
  paddingLeft,
  paddingTop,
  trackWidth,
  trackHeight,
  columnGap,
  rowGap,
}: {
  columns: number;
  rows: number;
  width: number;
  height: number;
  paddingLeft: number;
  paddingTop: number;
  trackWidth: number;
  trackHeight: number;
  columnGap: number;
  rowGap: number;
}) => {
  const canvasWidth = width - paddingLeft * 2;
  const canvasHeight = height - paddingTop * 2;

  const canvasRef = useRef<HTMLCanvasElement>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: migrated from develop
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    Array.from({ length: columns }).forEach((_, colIndex) => {
      Array.from({ length: rows }).forEach((_, rowIndex) => {
        const x = colIndex * (trackWidth + columnGap);
        const y = rowIndex * (trackHeight + rowGap);
        ctx.beginPath();
        ctx.rect(x, y, trackWidth, trackHeight);
        ctx.fillStyle = '#e9eef5';
        ctx.fill();
      });
    });

    return () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    };
  }, [
    width,
    height,
    columns,
    rows,
    paddingLeft,
    paddingTop,
    trackWidth,
    trackHeight,
    columnGap,
    rowGap,
  ]);

  return (
    <Box
      position="absolute"
      top={`${paddingTop}px`}
      left={`${paddingLeft}px`}
      width="100%"
      height="100%"
    >
      <canvas ref={canvasRef} width={canvasWidth} height={canvasHeight} />
    </Box>
  );
};
